import { render, staticRenderFns } from "./SupplierConnectionForm.vue?vue&type=template&id=c5b722b8"
import script from "./SupplierConnectionForm.vue?vue&type=script&lang=js"
export * from "./SupplierConnectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports